import SettingsModal from './SettingsModal.component';
import Settings from './Settings.component';
import SettingsContent from './SettingsContent.component';
import SettingsIdentifiers from './SettingsIdentifiers.enum';
import PackingSlipsView from './orders/PackingSlipsView.component';

export default {
	SettingsModal,
	Settings,
	SettingsContent,
	SettingsIdentifiers,
	PackingSlipsView,
};
